import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLoading = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 2.182,
			height: 6.545,
			x: 10.909,
			fill: "currentColor",
			fillOpacity: .5,
			rx: 1.091
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 2.182,
			height: 6.545,
			x: 10.909,
			fill: "currentColor",
			fillOpacity: .35,
			rx: 1.091,
			transform: "rotate(45 12 12)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 2.182,
			height: 6.545,
			x: 10.909,
			fill: "currentColor",
			fillOpacity: .3,
			rx: 1.091,
			transform: "rotate(90 12 12)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 2.182,
			height: 6.545,
			x: 10.909,
			fill: "currentColor",
			fillOpacity: .2,
			rx: 1.091,
			transform: "rotate(135 12 12)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 2.182,
			height: 6.545,
			x: 10.909,
			fill: "currentColor",
			fillOpacity: .15,
			rx: 1.091,
			transform: "rotate(180 12 12)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 2.182,
			height: 6.545,
			x: 10.909,
			fill: "currentColor",
			fillOpacity: .1,
			rx: 1.091,
			transform: "rotate(270 12 12)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 2.182,
			height: 6.545,
			x: 10.909,
			fill: "currentColor",
			fillOpacity: .1,
			rx: 1.091,
			transform: "rotate(315 12 12)"
		})
	]
});
export default SvgLoading;
